// src/views/Parametros/Informacion/EliminarInformacion.jsx
import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EliminarInformacion({
  registro = {},
  onClose = () => {},
  onDeleted = () => {},
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    setError("");
    setLoading(true);

    try {
      const id = registro.id;
      if (!id) throw new Error("ID de información no encontrado.");

      const url = apiRoutes.informacion.deleteUrl(id);

      await appFetchJson(url, { method: "DELETE" });

      onDeleted();
      onClose();
    } catch (e) {
      console.error("Error al eliminar:", e);

      let msg = "No se pudo eliminar la Información.";
      if (e.status === 404) msg = "La información ya no existe.";
      else if (e.status === 409)
        msg =
          e.bodyText ||
          "No se puede eliminar porque está siendo utilizada por otros registros.";

      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">Eliminar Información</h2>
      </div>

      <div className="px-6 pt-4">
        <div className="mb-4 px-4 py-3 text-sm" style={{ color: "#1e72c0" }}>
          ¿Está seguro que desea eliminar este registro?
        </div>

        <div className="bg-gray-50 px-6 py-6 mb-2">
          <div className="space-y-2">
            <div>
              <span className="text-gray-500 mr-1">Fecha:</span>
              <span className="font-medium">{registro.fecha ?? "—"}</span>
            </div>

            <div>
              <span className="text-gray-500 mr-1">Descripción:</span>
              <span className="font-medium">{registro.descripcion ?? "—"}</span>
            </div>

            <div>
              <span className="text-gray-500 mr-1">Cliente:</span>
              <span className="font-medium">
                {registro.clienteNombre ?? "—"}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 py-4 border-t flex items-center gap-2 modal-footer">
        <button className="btn-fil" onClick={handleDelete} disabled={loading}>
          {loading ? "Eliminando…" : "Eliminar"}
        </button>

        <button className="btn-fil" onClick={onClose}>
          Cancelar
        </button>
      </div>
    </div>
  );
}
